import { useEffect, useState } from "react";
import Layout from "../include/layout";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import $ from "jquery"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Col, Form, Row } from "react-bootstrap";
import AuteursService from "../../services/AuteursService";
import { useSelector } from "react-redux";

export default function ShowAuteurs() {

    //##########################/// METHODES ##########################///
    //navigate pour faire les redirections
    const location = useLocation()
    const [validationError, setValidationError] = useState({})
    const navigate = useNavigate();
    const token = useSelector(state => state.auth.token)

    //Creation des ascesseurs getters et setters pour tout le formulaire
    const [id, setId] = useState('')
    const [nom_auteur, setNom] = useState('')
    const [presentation, setPresentation] = useState('')
    const [nom_interlocuteur, setNomInterlocuteur] = useState('')
    const [prenoms_interlocuteur, setPrenomsInterlocuteur] = useState('')
    const [qualite, setQualite] = useState('')
    const [telephone, setTelephone] = useState('')
    const [statut, setStatut] = useState('')


    //get details data
    const show = async () => {
        await AuteursService.show(location.state.id,token).then((response) => {
            const data = response.data.auteur
            setId(data.id)
            setNom(data.nom_auteur)
            setPresentation(data.presentation)
            setNomInterlocuteur(data.nom_interlocuteur)
            setPrenomsInterlocuteur(data.prenoms_interlocuteur)
            setTelephone(data.telephone)
            setQualite(data.qualite)
            setStatut(data.statut_id ? data.get_statut.libelle : "")

        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            setValidationError(error.message)
        });
    }
    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.auteurs_edit, { state: { id: param } })
    }


    useEffect(() => {
        show();
        $("#submenu-4").addClass("show")
    }, [])

    //##########################/// END METHODES ##########################///


    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0 text-start">Gestion</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item"><Link to={myroutes.auteurs_index} >Auteurs</Link></li>
                                        <li className="breadcrumb-item active">Détails auteur </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Détails
                                <span className="btn btn-primary btn-sm mx-3" onClick={() => goToEdit(id)} title="Ajouter" ><i className="fas fa-edit"></i></span></h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-settings shadow-lg mb-5">
                        <div className="app-card-body py-2 mx-3">
                            
                            <Form className="mx-3 settings-form" style={{ textAlign: "left" }}>

                            <Row>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nom et prénom (auteur)<i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setNom(e.target.value)}
                                                value={nom_auteur}
                                                placeholder="Le nom de l'auteur"
                                                name="nom_auteur"
                                                aria-label="nom_auteur"
                                                maxLength={100}
                                                minLength={3}
                                                type="text"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nom interlocuteur <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setNomInterlocuteur(e.target.value)}
                                                value={nom_interlocuteur}
                                                placeholder="Le nom de l'interlocuteur"
                                                name="nom_interlocuteur"
                                                aria-label="nom_interlocuteur"
                                                maxLength={100}
                                                minLength={3}
                                                type="text"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Prénoms interlocuteur <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setPrenomsInterlocuteur(e.target.value)}
                                                value={prenoms_interlocuteur}
                                                placeholder="Le prénom de l'interlocuteur"
                                                name="prenoms_interlocuteur"
                                                aria-label="prenoms_interlocuteur"
                                                maxLength={100}
                                                minLength={5}
                                                type="prenoms_interlocuteur"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Téléphone <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setTelephone(e.target.value)}
                                                value={telephone}
                                                placeholder="61000001"
                                                name="telephone"
                                                aria-label="telephone"
                                                maxLength={15}
                                                minLength={8}
                                                type="number"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Qualite <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setQualite(e.target.value)}
                                                value={qualite}
                                                placeholder=""
                                                name="qualite"
                                                aria-label="qualite"
                                                maxLength={100}
                                                type="text"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Statuts <i className="text-danger">*</i> </Form.Label>
                                            <Form.Control className="border border-info border rounded-2"
                                                value={statut}
                                                placeholder=""
                                                name="statut"
                                                aria-label="statut"
                                                type="text"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} sm={12} className="form-group" >
                                        <Form.Group className="mb-3">
                                            <Form.Label>Présentation <i className="text-danger">*</i></Form.Label>
                                            <textarea class="form-control" disabled readOnly name="presentation" value={presentation} id="" rows="3"></textarea>
                                        </Form.Group>
                                    </Col>

                                </Row>
                            </Form>

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}